import './machineLogic.css';

import { setEnvironment } from '@vse/environment';
import { standalone } from '@vse/main';
import type { MachinelogicLibrary, Application, ApplicationBase } from '@vse/machinelogic/types';

interface initializeMachineLogicProps {
  library: MachinelogicLibrary
  navigate: (path: string) => void
  navigateToLandingPage: () => void
  onApplicationUploaded: (application: ApplicationBase | null) => void
}

export function initializeMachineLogic ({ library, navigate, navigateToLandingPage, onApplicationUploaded }: initializeMachineLogicProps): () => void {
  setEnvironment('pendant', 'application');

  const machineLogicContainer = $("<div id='main' class='h_layout spaced machine_logic_page'>");
  const leftPane = $("<div id='left_pane' class='v_layout'>");
  const rightPane = $("<div id='right_pane' class='v_layout'>");

  $('#guiContainer')
    .addClass('v_layout spaced')
    .append(
      machineLogicContainer.append(
        leftPane,
        rightPane,
      ),
    );

  standalone(library, navigate, { renderUi: true, leftPane, rightPane, navigateToLandingPage, onApplicationUploaded });

  const lApplications: Application[] = library.getMachineLogicAppList();
  if (lApplications.length > 0) {
    // we want to come back to the selected application, if there was one.
    if (library.getCurrentApplication() === null) {
      library.selectApplication(lApplications[0]);
    }

    const currentApplication = library.currentApplication;
    if (!lApplications[0].isReadOnly()) {
      lApplications[0].selectSequenceByName(currentApplication.getInitialSequence().mName);
    }
  }

  return () => {
    // When we remove an application we update the mCalibrationParts attribute of the Config object and try to deploy the changes
    // by setting the ConfigManager object as dirty. Meanwhile in the config page the apply config button tracks ConfigManager.mDirty
    // to determine if we need to deploy the config or not.
    // Due to this, if the user removes and application and quickly navigates to the Configuration page, the Apply configuration button
    // is active. To get around this, we manually deploy and toggle the mDirty flag if the ConfigManager payload is awaiting a deploy.
    if (library.getConfigManager().dirty) {
      library.getConfigManager().deploy();
      library.getConfigManager().dirty = false;
    }
  };
}
